import { useLocalObservable } from 'mobx-react-lite';
import { useEffect } from 'react';

import {
  ITextHighlighterPresenter,
  ITextHighlighterPresenterProps,
  THighlightLayout,
} from './TextHighlighter.types';
import { getHighlightParams } from './TextHighlighter.utils';

export function useTextHighlighterPresenter(
  props: ITextHighlighterPresenterProps
): ITextHighlighterPresenter {
  const { highlightedText, originalText, parentRef } = props;

  const presenter = useLocalObservable<ITextHighlighterPresenter>(() => ({
    highlightLayout: null,
    relativeTop: 0,

    setHighlightLayout(highlightLayout: THighlightLayout[] | null): void {
      presenter.highlightLayout = highlightLayout;
    },

    setRelativeTop(relativeTop: number): void {
      presenter.relativeTop = relativeTop;
    },
  }));

  useEffect(() => {
    const highlightParams = getHighlightParams(
      highlightedText,
      originalText,
      parentRef?.current as HTMLElement
    );
    presenter.setHighlightLayout(highlightParams?.highlightLayout || null);
    presenter.setRelativeTop(highlightParams?.relativeTop ?? 0);
  }, [highlightedText, originalText, parentRef]);

  return presenter;
}
